import type { SiteInfo } from "./types";

export function siteTemplateRendererCode(
    site: Pick<SiteInfo, "rendererCode" | "templateCode"> | null | undefined,
): string | null {
    return site?.rendererCode ?? site?.templateCode ?? null;
}
